import { Provider } from '@angular/core';
import {
  MAT_RADIO_DEFAULT_OPTIONS,
  MatRadioDefaultOptions,
} from '@angular/material/radio';
import { MAT_TABS_CONFIG, MatTabsConfig } from '@angular/material/tabs';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';

export const MATERIAL_FORM_FIELD_DEFAULTS: Provider = {
  provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
  useValue: {
    appearance: 'outline',
    floatLabel: 'auto',
    color: 'primary',
    hideRequiredMarker: false,
    subscriptSizing: 'dynamic',
  } as MatFormFieldDefaultOptions,
};

export const MATERIAL_TAB_DEFAULTS: Provider = {
  provide: MAT_TABS_CONFIG,
  useValue: { animationDuration: '0ms' } as MatTabsConfig,
};

export const MATERIAL_RADIO_DEFAULTS: Provider = {
  provide: MAT_RADIO_DEFAULT_OPTIONS,
  useValue: { color: 'primary' } as MatRadioDefaultOptions,
};
